import { useCallback } from 'react';
import { DownloadOutlined } from '@ant-design/icons';

import { Category, Document } from 'interfaces/documents';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { isCategory, isDocument } from '../../../../utilities/constants';
import { downloadDocument, bulkDownload } from 'slices/documentsActions';
import { useModal } from 'hooks/useModal';
import { modalName as downloadsModal } from 'modals/DownloadsModal';
import { MenuItemType } from 'antd/es/menu/interface';

export const Download = (
    row: Document | Category
): MenuItemType => {
    const dispatch = useAppDispatch();
    const { loading } = useAppSelector((state) => state.documents);
    const { openModal } = useModal();
    const downloadItem = useCallback(async () => {
        if (!row) return;

        try {
            if (isDocument(row)) {
                await dispatch(downloadDocument(row as Document)).unwrap();
            } else if (isCategory(row)) {
                const response = await dispatch(bulkDownload({
                    entities: [row.uuid.toString()],
                    filename: row.name
                })).unwrap();
                if (response && response.signature) {
                    openModal(downloadsModal);
                }
            }
        } catch (error) {}
    }, [row, dispatch]);

    return {
        key: 'Download',
        disabled: loading,
        icon: <DownloadOutlined />,
        onClick: () => downloadItem(),
        label: loading ? 'Downloading...' : 'Download',
    };
};
